<template>
    <div class="app-container">
        <div class="filter-container">
            <el-button type="warning" icon="el-icon-upload2" :loading="tableLoading"
                style="width: 125px;height: 40px;margin: -3px;" @click="exportExcel">导出Excel</el-button>

            <div class="right-filter">
                <div class="left">
                    <div style="min-width: 462px;">
                        <span>用户提交时间：</span>
                        <el-date-picker v-model="filteDateRange" size="medium" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm" clearable
                            @change="onChangeDateRange" />
                    </div>
                    <div>
                        <el-input v-model="listQuery.user_name" placeholder="用户昵称" clearable
                            style="max-width: 230px;"></el-input>
                    </div>
                    <div>
                        <el-input v-model="listQuery.commodity_name" placeholder="商品名称" clearable
                            style="max-width:230px;"></el-input>
                    </div>
                    <div>
                        <el-select v-model="listQuery.state" placeholder="状态" clearable>
                            <el-option label="待发货" :value="1" />
                            <el-option label="已发货" :value="2" />
                            <el-option label="已完成" :value="3" />
                            <el-option label="已取消" :value="4" />
                        </el-select>
                    </div>
                </div>

                <el-button type="primary" icon="el-icon-search" :loading="tableLoading" @click="handleFilter"
                    style="width: 89px;height: 40px;margin: 5px;">搜索</el-button>
            </div>
        </div>

        <el-table v-loading="tableLoading" element-loading-text="Loading" :data="tableData" border fit height="65vh"
            highlight-current-row>
            <el-table-column type="index" label="序号" width="95" align="center" />
            <el-table-column prop="order_id" label="订单号" min-width="200" align="center" />
            <!-- <el-table-column prop="commodity_info.name" label="商品名称" min-width="200" align="center" /> -->

            <el-table-column label="商品名称" align="center" min-width="200">
                <template slot-scope="scope">{{
                    scope.row.commodity_log ? (scope.row.commodity_log.commodity_name ?
                        scope.row.commodity_log.commodity_name : scope.row.commodity_info.name) : scope.row.commodity_info.name
                }}</template>
            </el-table-column>

            <el-table-column label="规格" align="center" min-width="150">
                <template slot-scope="scope">{{ scope.row.commodity_log ? scope.row.commodity_log.product_specifications :
                    '-'
                }}</template>
            </el-table-column>

            <el-table-column prop="user_info.name" label="用户名" min-width="150" align="center" />
            <el-table-column prop="expend_integral" label="消耗积分" width="100" align="center" />
            <el-table-column prop="num" label="数量" width="100" align="center" />




            <el-table-column prop="user_last_at" label="用户提交时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.user_last_at}}
                    </div>
                </template>
            </el-table-column>



            <el-table-column prop="admin_last_at" label="管理员最新操作时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.admin_last_at}}
                    </div>
                </template>
            </el-table-column>


            <el-table-column prop="state" label="状态" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.state === 1" type="warning">待发货</el-tag>
                    <el-tag v-else-if="scope.row.state === 2">已发货</el-tag>
                    <el-tag v-else-if="scope.row.state === 3" type="success">已完成</el-tag>
                    <el-tag v-else-if="scope.row.state === 4" type="info">已取消</el-tag>
                    <el-tag v-else type="danger">未知</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="170" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="checkDetailTable(scope.row)">详情</el-button>
                    <el-button v-if="scope.row.state === 1" type="primary" size="mini"
                        @click="onShipment(scope.row.order_id)">发货</el-button>
                    <el-button v-else-if="scope.row.state === 2" type="primary" size="mini"
                        @click="onReceived(scope.row.order_id, '确认收货')">确认收货</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </div>

        <TableActiveModal v-if="visible" :show.sync="visible" :table-data="rowDetail" />
        <Shipment v-if="shipmentVisible" :show.sync="shipmentVisible" :order_id="shipmentOrder_id"
            @onUpdate="onTableActionModalSubmit" />
    </div>
</template>

<script>
// 积分商城 订单列表
import TableActiveModal from "./components/TableActiveModal.vue"
import Shipment from "./components/Shipment.vue"
import { orderList } from "@/api/creditShop"
import * as XLSX from "xlsx"

export default {
    data: () => ({
        tableLoading: false,
        tableData: [],
        listQuery: {
            page: 1,
            limit: 10,
            user_name: '',
            commodity_name: '',


            user_last_start_at: null,
            user_last_end_at: null,
        },
        filteDateRange: null,
        total: null,
        visible: false,
        rowDetail: null,
        shipmentVisible: false,
        shipmentOrder_id: null
    }),
    components: { TableActiveModal, Shipment },
    methods: {
        async getList() {
            this.tableLoading = true
            this.tableData = []
            const { data } = await orderList.list(this.listQuery)
            this.tableData = data.data
            this.total = data.total
            this.tableLoading = false
        },
        // 选择时间
        onChangeDateRange(t) {
            if (t === null) {
                this.listQuery.user_last_start_at = null
                this.listQuery.user_last_end_at = null
            }
            this.listQuery.user_last_start_at = t[0]
            this.listQuery.user_last_end_at = `${t[1].split(' ')[0]} 23:59:59`
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        checkDetailTable(row) {
            this.rowDetail = row
            this.visible = true
        },
        onShipment(id) {
            this.shipmentOrder_id = id
            this.shipmentVisible = true
        },
        onTableActionModalSubmit() {
            this.getList()
        },
        onReceived(order_id, text) {
            this.$confirm("此操作将" + text + "该订单, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(async () => {
                    try {
                        await orderList.signature(order_id)
                        this.$message({
                            type: "success",
                            message: "操作成功!"
                        });
                        this.getList()
                    } catch {
                        // this.$message.error('出错了!');
                    }
                })
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')
            // +++修改excel-积分商城-订单列表-附件4---ok
            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await orderList.exportCreditShopExcel({ ...this.listQuery, page: 1, limit: 99999999999 })

                var wb = XLSX.utils.book_new();


                var excelData = [
                    ['序号', '订单号', '名称', '规格', '收货人', '手机号码', '地址', '邮编', '物流公司', '物流编码', '用户名', '性別', '年龄', '手机号', '居住地-国家', '居住地-省份', '微信ID', '邮箱', '擅长领域', '消耗积分', '数量', '状态'],
                    ...reqData.map((item, index) => [
                        index + 1,
                        item.order_id,
                        item.commodity_info.name,
                        item.commodity_log ? item.commodity_log.product_specifications : '-',
                        item.user_address_log ? item.user_address_log.user_name : '',
                        item.user_address_log ? item.user_address_log.user_phone : '',
                        item.user_address_log ? item.user_address_log.address_details : '',
                        item.user_address_log ? item.user_address_log.postal_code : '',
                        item.logistics_log ? item.logistics_log.logistics_name : '',
                        item.logistics_log ? item.logistics_log.logistics_number : '',
                        item.user_info.name,
                        item.user_info.gender === 1 ? '男性' : item.user_info.gender === 2 ? '女性' : '未设置',
                        item.user_info.age_group === 1 ? '20岁以下' : item.user_info.age_group === 2 ? '21~30岁' : item.user_info.age_group === 3 ? '31~40岁' : item.user_info.age_group === 4 ? '41~50岁' : item.user_info.age_group === 5 ? '51岁以上' : '未设置',
                        item.user_info.account,
                        item.user_info.country,
                        item.user_info.provinces,
                        item.user_info.wx_id,
                        item.user_info.email,
                        item.user_info.evaluation_type_field.length > 0 ? item.user_info.evaluation_type_field.map(item => item.name).join(',') : '',
                        item.expend_integral,
                        item.num,
                        item.state === 1 ? '待发货' : item.state === 2 ? '已发货' : item.state === 3 ? '已完成' : item.state === 4 ? '已取消' : '无字段'
                    ])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "订单列表");
                XLSX.writeFile(wb, "积分商城-订单列表.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
.filter-container {
    display: flex;
    flex-wrap: nowrap;
    // align-items: center;
    justify-content: space-between;

    .right-filter {
        display: flex;
        margin: -5px;
        justify-content: space-between;


        .left {
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;


            &>* {
                margin: 5px;
            }
        }
    }
}
</style>